import { FileUploadModalContent } from '@/components/PatientModal/file-upload-modal.tsx';

import { ModalType } from '@/models/Modal.ts';

import { openModal } from '@/services/modalService.tsx';

interface OpenFileUploadModalParams {
    userId: string;
    appointmentId?: string;
    instanceId?: string;
    onUploadSuccess?: () => void;
}

export const openFileUploadModal = ({
    userId,
    appointmentId,
    instanceId,
    onUploadSuccess,
}: OpenFileUploadModalParams): void => {
    openModal({
        modalId: ModalType.FILE_UPLOAD,
        title: 'Dokument hochladen',
        size: 'md',
        children: (
            <FileUploadModalContent
                userId={userId}
                appointmentId={appointmentId}
                instanceId={instanceId}
                onUploadSuccess={onUploadSuccess}
            />
        ),
    });
};
